import React from 'react';
import i18next from 'i18next';
import cn from 'classnames';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import Icon from '../../Icon/Icon';
import PendingButton from '../../Button/PendingButton';
import Cancellable from '../../Cancellable/Cancellable';
import Api from '../../../api';

const icons = {
  BTC: require('icons/bitcoin.svg'),
  BCH: require('icons/bitcoin_cash.svg'),
  ETH: require('icons/ethereum.svg'),
  LTC: require('icons/litecoin.svg'),
};

export default class CryptoWallet extends Cancellable {
  constructor(props) {
    super(props);

    this.state = {
      copied: false,
      pending: false,
    };
  }

  createWallet = () => {
    const { id } = this.props;

    this.setState({ pending: true });

    this.request(Api.createWallet(id)).then(() => {
      this.props.onWalletCreated(id);
    });
  };

  handleAddressClick = () => {
    this.props.onAddressClick(this.props.id);
  };

  componentDidUpdate() {
    if (this.state.pending && this.props.address) {
      this.setState({ pending: false });
    }

    if (this.state.copied) {
      this.timer = setTimeout(() => {
        this.setState({
          copied: false,
        });
      }, 600);
    }
  }

  render() {
    const { copied, pending } = this.state;
    const { id, name, address } = this.props;

    return (
      <div className="crypto-wallet">
        <div className="crypto-wallet__icon">
          <Icon glyph={icons[id]} />
        </div>

        <span className="crypto-wallet__name">{name}</span>

        {address ? (
          <CopyToClipboard
            text={address}
            onCopy={() => this.setState({ copied: true })}
            className={cn('link link--yellow crypto-wallet__address', {
              copied: copied,
            })}
          >
            <span onClick={this.handleAddressClick}>{address}</span>
          </CopyToClipboard>
        ) : (
          <PendingButton
            tagName="button"
            type="button"
            className="crypto-wallet__create-button"
            view="default"
            defaultStyles={true}
            pending={pending}
            disabled={pending}
            onClick={this.createWallet}
          >
            {i18next.t('crypto_wallet.create')}
          </PendingButton>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./app/components/Crypto/CryptoWallet/CryptoWallet.jsx